function isViewType(value) {
  return ['grid', 'list'].includes(value);
}

export { isViewType };
//# sourceMappingURL=queryParams.esm.js.map
